import {
  ROLE_ADMIN,
  ROLE_AGENT,
  ROLE_MANAGER,
  ROLE_MODERATOR,
  ROLE_SUPER_ADMIN,
  ROLE_USER,
} from "src/constants";
import {Role} from "types/global";

export const ROLE_RANK: Record<Role, number> = {
  [ROLE_USER]: 1,
  [ROLE_AGENT]: 2,
  [ROLE_MODERATOR]: 3,
  [ROLE_MANAGER]: 4,
  [ROLE_ADMIN]: 5,
  [ROLE_SUPER_ADMIN]: 6,
};

export const getRoleRank = (role: Role): number => ROLE_RANK[role] ?? 0;

export const isRoleAtLeast = (role: Role, atLeast: Role): boolean =>
  getRoleRank(role) >= getRoleRank(atLeast);

export const isAtLeastManager = (role: Role) =>
  isRoleAtLeast(role, ROLE_MANAGER);

export const isAtLeastAdmin = (role: Role) => isRoleAtLeast(role, ROLE_ADMIN);

export const isAtLeastModerator = (role: Role) =>
  isRoleAtLeast(role, ROLE_MODERATOR);

export const isSuperAdmin = (role: Role) => role === ROLE_SUPER_ADMIN;
